import React, { useState } from 'react';

const HotelImageGallery = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(images[0]);

  return (
    <div className="flex flex-col md:flex-col-2  gap-4 w-full max-w-6xl mx-auto px-4">
      {/* Main Image */}
      <div className="flex-1 rounded-xl overflow-hidden relative group aspect-video">
        <img
          src={selectedImage.src}
          alt="Main"
          className="w-full h-full object-cover transition duration-300"
        />
        {selectedImage.label && (
          <div className="absolute bottom-2 left-2 text-white font-semibold bg-black/50 px-2 py-1 rounded text-sm">
            {selectedImage.label}
          </div>
        )}
      </div>

      {/* Side Thumbnails */}
      <div className="flex flex-col-3 gap-4 w-full md:w-1/3">
        {images.slice(1, 5).map((img, index) => (
          <div
            key={index}
            onClick={() => setSelectedImage(img)}
            className="cursor-pointer relative group rounded-xl overflow-hidden aspect-[3/2] hover:scale-[1.02] transition"
          >
            <img
              src={img.src}
              alt={`Thumb ${index}`}
              className="w-full h-full object-cover"
            />
            {img.label && (
              <div className="absolute bottom-2 left-2 text-white font-semibold bg-black/50 px-2 py-1 rounded text-sm">
                {img.label}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HotelImageGallery;
